import * as React from 'react';
import BaseList from '../BaseList/BaseList';

class VehicleTypeList extends BaseList {
  constructor(props) {
    super(props, {
      fields: BaseList.fields.vehicleTypes.search,
      search: BaseList.search.vehicleTypes,
      path: 'settings/vehicles/types',
      name: 'types',
    });
  }

  renderLeft(item) {
    if (!item || !item.image) {
      return null;
    }
    return (
      <span className="avatar image is-64x64">
        {console.log(item, 'vehicle type')}
        <img src={item.image} alt={item.name} />
      </span>
    );
  }
}

export default VehicleTypeList;
